import currentUserSelector from './currentUserSelector'

const currentUserInstitutionIdSelector = () => {
  const user = currentUserSelector()

  return user?.institution?.replace('/api/groups/', '')
}

export default currentUserInstitutionIdSelector
